import React from "react";

import { useSelector } from "react-redux";

import { useGetApplicationQuery } from "../api";
import LetterPreview, { letterPreviewPropsFromBorApplication } from "../components/LetterPreview";
import { SUPPORTED_CARRIER_HASH } from "../constants";
import BodyText from "Common/BodyText";
import { CardSection } from "Common/Card";
import { Row, Col } from "Common/Grid";
import { Ul, Li } from "Common/HTML";
import { usePartnerContext } from "Common/PartnerContext";

const DonePage = () => {
  const { data: borApplication, error: _error } = useGetApplicationQuery();

  const { borMedicalInsuranceCompany, borOtherMedicalInsuranceCompany } = borApplication;
  let carrier = borMedicalInsuranceCompany !== "other" ? borMedicalInsuranceCompany : borOtherMedicalInsuranceCompany;
  carrier = carrier && (SUPPORTED_CARRIER_HASH[carrier] || carrier);

  const { partnerCasualName } = usePartnerContext();

  return (
    <CardSection>
      <Row className="text-center">
        <Col p={4} xs={6} xsOffset={3}>
          <BodyText size="x-large" agent>
            Congratulations!
          </BodyText>
        </Col>
      </Row>
      <Row>
        <Col pl={5}>
          <BodyText size="large">Our team will process the change and integrate your benefits into {partnerCasualName}. Here's what happens next:</BodyText>
        </Col>
      </Row>
      <Row>
        <Col p={4}>
          <Ul>
            <Li>SimplyInsured (agent: Vivek Shah) will now become the Broker of Record for your health insurance policy.</Li>
            <Li>
              In approximately 7-14 business days, your integration will be completed. Your health insurance coverage and benefits will not be impacted during
              this time.
            </Li>
            <Li>You will receive an email confirming your benefits are set up - and giving you access to your management dashboard.</Li>
          </Ul>
        </Col>
      </Row>
      <Row>
        <Col pl={5}>
          <BodyText size="large">We will send the following letter to {carrier} on your behalf:</BodyText>
        </Col>
      </Row>
      <LetterPreviewRow />
    </CardSection>
  );
};

const LetterPreviewRow = () => {
  const propsFromBorApplication = useSelector(letterPreviewPropsFromBorApplication);

  return (
    <Row>
      <Col p={6}>
        <LetterPreview {...propsFromBorApplication} />
      </Col>
    </Row>
  );
};
export default DonePage;
